import { userQueryKeys } from '@/config/queryKeys';
import { checkAndRedirectForOrgAdminAccess } from '@/helpers';
import { apiClient } from '@/lib';
import { useAppStore } from '@/stores/app';
import type { UserPublic, UserStudyPublic } from '@/types';
import { SUPER_ADMIN_ROLE } from '@/types';
import { createFileRoute, redirect } from '@tanstack/react-router';

// TODO: Re-enable OrgAdmin once GET /orgs/{id}/users returns results for
// non-SuperAdmin roles (same blocker as users list).
const allowedRoles = [SUPER_ADMIN_ROLE];

export const Route = createFileRoute('/users/$userId')({
  beforeLoad: ({ context, location }) => {
    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;
    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles: allowedRoles,
      redirect,
    });
  },
  loader: ({ context: { queryClient }, params: { userId } }) => {
    void queryClient.ensureQueryData({
      queryKey: userQueryKeys.detail(userId),
      queryFn: () => apiClient.get<UserPublic>(userQueryKeys.endpoints.detail(userId)),
      staleTime: Infinity,
    });
    void queryClient.ensureQueryData({
      queryKey: userQueryKeys.studies(userId),
      queryFn: async () => (await apiClient.get<UserStudyPublic[]>(userQueryKeys.endpoints.studies(userId))) ?? [],
      staleTime: 5 * 60 * 1000,
    });
  },
});
